import styled from "styled-components";

export const Section = styled("div")<{ verticalSpacing?: boolean }>`
    >a,>p,>h1,>h2,>h3,>h4,>h5,>h6 {
        margin-bottom: ${({verticalSpacing}) => verticalSpacing && '1rem'};
    }
    margin-bottom: 2rem
`;